export default __webpack_public_path__ + "static/media/m_session7_1.148e47ae.png";